import * as Config from '../../../../config';
import React from 'react';
import PropTypes from 'prop-types';

function IconActions({ size = 24, color = Config.TYPE_DARK_SECONDARY, className, style }) {
  return (
    <svg className={className} style={style} width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="5.5" cy="12.5" r="1.5" fill={color}/>
      <circle cx="11.5" cy="12.5" r="1.5" fill={color}/>
      <circle cx="17.5" cy="12.5" r="1.5" fill={color}/>
    </svg>
  )
}

IconActions.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  className: PropTypes.string,
  style: PropTypes.object
}

export default IconActions;
